/** Подписи ролей (erp_v2.roles.title, миграция 0003) — для футера sidebar и меню профиля. */
export const ROLE_LABELS: Record<string, string> = {
  owner: 'Владелец',
  director: 'Директор',
  sales: 'Продажи',
  production_manager: 'Руководитель производства',
  procurement: 'Закупки',
  warehouse: 'Склад',
  decoration: 'Нанесение',
  qc: 'ОТК',
  packaging: 'Упаковка',
  finance: 'Финансы',
  planner: 'Планировщик',
  viewer: 'Наблюдатель',
  portal_workshop: 'Портал цеха',
};

/** Первая роль актора — человекочитаемо; без ролей — «Сотрудник». Неизвестный код не показываем сырым. */
export function roleLabel(roles: readonly string[]): string {
  const known = roles.map((r) => ROLE_LABELS[r]).filter((x): x is string => Boolean(x));
  const first = known[0];
  if (first === undefined) return 'Сотрудник';
  return known.length === 1 ? first : `${first} +${known.length - 1}`;
}
